import React, { useEffect, useState } from 'react';
import constant from '../../constant';
import { v2_ships } from '../../actions/v2/projectAndVessel';
import { toast } from 'react-toastify';
import { v2_categories } from '../../actions/v2/masterData';
import { v3_upload_plan_approval_document } from '../../actions/v3/planApproval';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const mapDocumentForEdit = (doc) => ({
  fileName: doc.FILE_NAME || doc.fileName,
  originalFileName: doc.ORIGINAL_FILE_NAME || doc.originalFileName,
  existing: true
});

const CreatePlanApprovalForm = ({ projectId, projectName, onSubmit, data }) => {
  const [state, setState] = useState({
    hullId: { name: 'hullId', value: data ? data.SHIP_ID : '', options: [], isRequired: false, error: '' },
    drawingName: { name: 'drawingName', value: data ? data.DRAWING_NAME : '', isRequired: true, error: '' },
    drawingCode: { name: 'drawingCode', value: data ? data.DRAWING_CODE : '', isRequired: true, error: '' },
    categoryId: { name: 'categoryId', value: data ? data.CATEGORY_ID : '', options: [], isRequired: true, error: '' },
    remark: { name: 'remark', value: data ? data.REMARK : '', isRequired: false, error: '' },
    documentFiles: {
      name: 'documentFiles',
      value: data ? ((data.DOCUMENTS || []).map(mapDocumentForEdit)) : [{ fileName: '', originalFileName: '', existing: false }],
      isRequired: false,
      error: ''
    },
  });

  useEffect(() => {
    if (!data) return;
    const mappedDocuments = (data.DOCUMENTS || []).map(mapDocumentForEdit);

    setState((prev) => ({
      ...prev,
      hullId: { ...prev.hullId, value: data.SHIP_ID || '' },
      drawingName: { ...prev.drawingName, value: data.DRAWING_NAME || '' },
      drawingCode: { ...prev.drawingCode, value: data.DRAWING_CODE || '' },
      categoryId: { ...prev.categoryId, value: data.CATEGORY_ID || '' },
      remark: { ...prev.remark, value: data.REMARK || '' },
      documentFiles: {
        ...prev.documentFiles,
        value: mappedDocuments.length > 0 ? mappedDocuments : [],
        error: ''
      }
    }));
  }, [data]);

  useEffect(() => {
    v2_ships(null, projectId, null).then((res) => {
      if (res.status) {
        setState(prev => ({
          ...prev,
          hullId: {
            ...prev.hullId,
            options: res.result.map((item) => {
              return {
                ...item,
                id: item.ID,
                name: item.HULL_NUMBER + ' - ' + item.SHIP_NAME
              }
            }) || []
          }
        }))
      }
      else {
        toast.error(res.error || res.error.message)
      }
    })

    v2_categories().then((res) => {
      if (res.status) {
        setState(prev => ({
          ...prev,
          categoryId: {
            ...prev.categoryId,
            options: res.result.map((item) => {
              return {
                id: item.ID,
                name: item.CATEGORY_NAME
              }
            }) || []
          }
        }));
      }
    })

  }, [projectId])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState(prev => ({
      ...prev,
      [name]: { ...prev[name], value, error: '' }
    }));
  };

  const renderInput = (label, name, placeholder = '') => {
    return (

      <div className="col-md-6 mb-3" key={name}>
        <label>{label}
          {state[name].isRequired ? <span className='text-danger'>*</span> : ''}
        </label>
        <input
          type="text"
          name={name}
          value={state[name].value}
          placeholder={placeholder}
          onChange={handleChange}
          className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
        />
        {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
      </div>
    )
  }


  const renderSelect = (label, name, options = []) => (
    <div className="col-md-6 mb-3" key={name}>
      <label>{label} {state[name].isRequired ? <span className='text-danger'>*</span> : ''}</label>
      <select
        name={name}
        value={state[name].value}
        onChange={handleChange}
        className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
      >
        <option value="">Select {label}</option>
        {options.map(opt => (
          <option key={opt.id} value={opt.id}>{opt.name}</option>
        ))}
      </select>
      {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
    </div>
  );
  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;
    const updatedState = { ...state };

    Object.keys(state).forEach((key) => {
      if (state[key].isRequired && !state[key].value) {
        updatedState[key].error = 'This field is required';
        isValid = false;
      }
    });

    setState(updatedState);
    if (!isValid) {
      toast.error('Please fill all required fields.');
      return;
    }

    const payload = {
      projectId,
      drawingName: state.drawingName.value,
      drawingCode: state.drawingCode.value,
      hullId: state.hullId.value,
      categoryId: state.categoryId.value,
      remarks: state.remark.value,
      documentFiles: state.documentFiles.value,
    };
    onSubmit(payload)
  };


  const handleFileChange = (index, file) => {
    const formData = new FormData();
    formData.append('file', file);

    v3_upload_plan_approval_document(formData).then((res) => {
      if (res.status && res.result) {
        const updatedFiles = [...state.documentFiles.value];
        updatedFiles[index] = {
          fileName: res.result.fileName,
          originalFileName: res.result.originalFileName,
          existing: false
        };

        setState(prev => ({
          ...prev,
          documentFiles: {
            ...prev.documentFiles,
            value: updatedFiles,
            error: updatedFiles.length === 0 ? 'This field is required' : ''
          }
        }));
      }
    });
  };

  const replaceFileAtIndex = (index) => {
    const updatedFiles = [...state.documentFiles.value];
    updatedFiles[index] = { fileName: '', originalFileName: '', existing: false };

    setState(prev => ({
      ...prev,
      documentFiles: {
        ...prev.documentFiles,
        value: updatedFiles,
        error: ''
      }
    }));
  };

  const addFileField = () => {
    setState(prev => ({
      ...prev,
      documentFiles: {
        ...prev.documentFiles,
        value: [...prev.documentFiles.value, { fileName: '', originalFileName: '', existing: false }],
        error: ''
      }
    }));
  };

  const removeFileField = (index) => {
    const updatedFiles = state.documentFiles.value.filter((_, i) => i !== index);
    setState(prev => ({
      ...prev,
      documentFiles: {
        ...prev.documentFiles,
        value: updatedFiles,
        error: updatedFiles.length === 0 ? 'At least one document is required' : ''
      }
    }));
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        {renderInput('Drawing Name', state.drawingName.name, 'Enter Plan Name')}
        {renderInput('Drawing Code', state.drawingCode.name, 'Enter Plan Number')}
        {renderSelect('Hull', 'hullId', state.hullId.options)}
        {renderSelect('Category', 'categoryId', state.categoryId.options)}
        <div className="col-md-12 mb-3">
          <label>Upload Documents</label>

          {state.documentFiles.value.map((item, index) => (
            <div key={index} className="d-flex align-items-center mb-2">
              {item.fileName ? (
                <>
                  <div className="me-2 flex-grow-1">
                    <span>{item.originalFileName}</span>
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-secondary me-2"
                    onClick={() => replaceFileAtIndex(index)}
                  >
                    Replace
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={() => removeFileField(index)}
                  >
                    <FaTrash />
                  </button>
                </>
              ) : (
                <>
                  <input
                    type="file"
                    onChange={(e) => handleFileChange(index, e.target.files[0])}
                    className="form-control me-2"
                  />
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={() => removeFileField(index)}
                  >
                    <FaTrash />
                  </button>
                </>
              )}
            </div>
          ))}
          <div>
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={addFileField}
            >
              <FaPlus className="me-1" /> Add Document
            </button>
          </div>

          {state.documentFiles.error && (
            <div className="text-danger mt-1">{state.documentFiles.error}</div>
          )}
        </div>
      </div>

      <div className="mt-3">
        <button type="submit" className="btn btn-success me-2">{data ? 'Update' : 'Submit'}</button>
        <Link className="btn btn-danger text-white" to={{
          pathname: constant.Authedcomponent.finalDrawingDetail.url,
          state: {
            projectId,
            projectName
          }
        }
        }>Cancel</Link>
      </div>
    </form >
  );
};

export default CreatePlanApprovalForm;
